export default "__VITE_ASSET__BND8nDGX__"